import { render, staticRenderFns } from "./DocumentationPageIOS.vue?vue&type=template&id=63be78d6&scoped=true&"
import script from "./DocumentationPageIOS.vue?vue&type=script&lang=js&"
export * from "./DocumentationPageIOS.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationPageIOS.vue?vue&type=style&index=0&id=63be78d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be78d6",
  null
  
)

export default component.exports